export function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

export function scrollToOffset(offset: number, behavior: ScrollBehavior = 'smooth') {
  window.scrollTo({
    top: offset,
    behavior,
  });

  return offset;
}

export function scrollToElement(element: HTMLElement) {
  element.scrollIntoView({
    behavior: 'smooth',
  });
}

export function getCurrentScroll() {
  return window.scrollY;
}